/* Progressive photo controls only. No network, cart or inventory writes. */
(() => {
  'use strict';
  if (customElements.get('gto-catalog-card')) return;
  class GtoCatalogCard extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      const controls=this.querySelector('.gto-catalog-card__switch'), front=this.querySelector('.gto-catalog-card__image--front'), back=this.querySelector('.gto-catalog-card__back');
      if (!controls || !front || !back) return;
      this._bound=true; controls.hidden=false;
      controls.addEventListener('click',event=>{
        const button=event.target.closest('button[data-gto-side]');
        if (!button || !controls.contains(button)) return;
        const showBack=button.dataset.gtoSide==='back'; front.hidden=showBack; back.hidden=!showBack;
        controls.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        const status=this.querySelector('[data-gto-side-status]'); if(status)status.textContent=showBack?'Back photograph shown.':'Front photograph shown.';
      });
    }
  }
  customElements.define('gto-catalog-card',GtoCatalogCard);
})();
